import axios from 'axios'
import moment from 'moment'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'

export default {
  async retrieveOngoingActivities ({ commit }) {
    try {
      const userId = store.get('user').id
      const startDate = moment.utc().subtract(4, 'hours').format('YYYY-MM-DD HH:mm:ss')

      const response = await axios.get(`${jiminnyHost()}/api/v1/page/on-demand`, {
        params: {
          'status': ['in-progress'],
          'start_date': startDate,
          'min_duration': 0,
          'participant_user_id': [userId],
          'sequence_number': '1'
        }
      })

      const activities = response.data.results.filter(activity => activity.provider !== 'twilio')

      // Move own activities to the beginning
      activities.sort((a1, a2) => {
        if (a1.organizer.id === userId && a2.organizer.id !== userId) {
          return -1
        } else if (a1.organizer.id === userId && a2.organizer.id === userId) {
          return 0
        } else {
          return 1
        }
      })

      commit('SET_ONGOING_ACTIVITIES', activities)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_ONGOING_ACTIVITIES_FETCHED', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/global/actions.js